// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__vIVWT","activeLink":"Navigation_activeLink__1Fkh9"};